import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';

function IsShowModal({ deed, closeDeed, modalContent, title, notFullScrin }) {
  const [isOpen, setisOpen] = useState(false);
  const [isTransp, setisTransp] = useState(false);
  const [check, setCheck] = useState(false);

  const setTest = (doIt) => {
    if (doIt === 'open') {
      setisTransp(true);
      setTimeout(() => {
        setisOpen(true);
      }, 200);
    }
    if (doIt === 'close') {
      setisOpen(false);
      setTimeout(() => {
        setisTransp(false);
      }, 200);
    }
  };

  useEffect(() => {
    if (deed && !check) {
      setCheck(true);
      setTest('open');
    }
    if (!deed && check) {
      setCheck(false);
      setTest('close');
    }
  }, [deed, check]);

  return (
    <Modal
      closeAction={() => {
        closeDeed.call();
      }}
      visible={isOpen}
      transition={isTransp}
      title={title}
      notFullScrin={notFullScrin}
    >
      {modalContent}
    </Modal>
  );
}

IsShowModal.propTypes = {
  deed: PropTypes.bool,
  notFullScrin: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  closeDeed: PropTypes.func,
  modalContent: PropTypes.shape().isRequired,
};

IsShowModal.defaultProps = {
  title: false,
  deed: false,
  notFullScrin: false,
  closeDeed: () => {},
};

export default IsShowModal;
